import { render, staticRenderFns } from "./MyMediaAccreditationEventLandingPage.vue?vue&type=template&id=5b33b146&scoped=true"
import script from "./MyMediaAccreditationEventLandingPage.vue?vue&type=script&lang=js"
export * from "./MyMediaAccreditationEventLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33b146",
  null
  
)

export default component.exports